import * as React from 'react';
import gql from 'graphql-tag';
import { client as clientGql } from "src";
import { Dialog, DialogTitle, DialogContent, Grid, FormControl, InputLabel, Select, MenuItem, DialogActions, Button } from '@material-ui/core';

// tslint:disable-next-line:no-empty-interface
export interface IDialogImportPartnerDataPros {
    clientF: any,
    isOpened: boolean,
    queryUpload: any,
    handleDialogImportPartnerDataClose():void,
    openSnackMessage(message:string):void,
}

// tslint:disable-next-line:no-empty-interface
export interface IDialogImportPartnerData {
    file:File|undefined,
    partnerSelected:number,
    partners: any[],
}

const QUERY_FIND_PARTNERS = gql`
    query findVejaPartners {
        findVejaPartners {
            id,
            name
        }
    }
`;

export class DialogImportPartnerData extends React.Component<IDialogImportPartnerDataPros, IDialogImportPartnerData> {

    constructor(props: IDialogImportPartnerDataPros) {
        super(props);
        this.state = {
            file:undefined,
            partnerSelected: 0,
            partners: [],
        }

        this.handleChangePartnerUpload = this.handleChangePartnerUpload.bind(this);
        this.handleChangeFile = this.handleChangeFile.bind(this);
    }

    public componentWillMount() {
        clientGql.query({
            query: QUERY_FIND_PARTNERS
        }).then((response) => {
            this.setPartnersList(response);
        });
    }

    public render() {
  
        return (
            <Dialog
                open={this.props.isOpened}
                onClose={this.props.handleDialogImportPartnerDataClose}
                aria-labelledby="economic-group-dialog-title"
                aria-describedby="alereconomic-group-dialog-description"
                maxWidth='md'
                fullWidth={true}
                disableBackdropClick={false}
                disableEscapeKeyDown={false}
            >
                <DialogTitle className="filter-dialog-title" id="economic-group-dialog-title">
                    {"Importação de dados de venda de parceiros"}
                </DialogTitle>
                <DialogContent>
                    <form autoComplete="off">
                        <Grid container={true} className="analytical-header">
                            <Grid item={true} xs={6}>
                                <FormControl className='half-width' >
                                    <InputLabel htmlFor="age-simple">Fornecedor: </InputLabel>
                                    <Select
                                        value={this.state.partnerSelected}
                                        onChange={this.handleChangePartnerUpload}
                                        inputProps={{
                                            id: 0,
                                            name: 'partnerSelectedId',
                                        }}
                                    >
                                        {
                                            this.state.partners.map((partner:any, key:number) => (
                                                <MenuItem value={partner.id}>{partner.name}</MenuItem>
                                            ))
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item={true} xs={6}>
                                <FormControl className='half-width'>
                                    <InputLabel htmlFor="file-input" >
                                        <Button variant="contained" component="span">
                                            Arquivo
                                        </Button>
                                        <span className='file-name'>{this.state.file && this.state.file.name ? this.state.file.name : ''}</span>
                                    </InputLabel>
                                    <input
                                        id="file-input"
                                        type="file"
                                        accept=".xlsx"
                                        multiple={false}
                                        onChange={ this.handleChangeFile }
                                        key={this.state.file && this.state.file.name ? this.state.file.name : ''}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleDialogImportPartnerDataClose} color="secondary">
                        Cancelar
                    </Button>
                    <Button onClick={this.requestImportPartnerData.bind(this, this.props.clientF)} color="primary" autoFocus={true}>
                        Importar
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    private requestImportPartnerData = async (client: any) => {
        if(!this.state.partnerSelected || this.state.partnerSelected <= 0) {
            this.props.openSnackMessage("É necessário selecionar o fornecedor do dado");
        } else if (!this.state.file || this.state.file === undefined) {
            this.props.openSnackMessage("É necessário adicionar 1 arquivo de formato .xlsx");
        } else {
            const base64 : any = await this.convertBase64(this.state.file);

            const jsonFilter = {
                "customFilter": {
                    "file": base64,
                    "partnerId": this.state.partnerSelected,
                }
            };

            this.props.openSnackMessage("Carregando...");
            this.setState({file:undefined , partnerSelected:0});
            await client.mutate({
                mutation: this.props.queryUpload,
                variables: jsonFilter
            }).then( (data:any,errors:any) => {
                if(errors && errors.length > 0) {
                    this.props.openSnackMessage(errors.message);
                }
    
                this.props.openSnackMessage("Arquivo importado com sucesso!");
            }).catch((errors:any) => {
                if(errors && errors.message.length > 0) {
                    this.props.openSnackMessage(errors.message);
                } else {
                    this.props.openSnackMessage('Falha ao importar dados!');
                }
            });
        }
    }

    private convertBase64 (file:File) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                if(reader.result) {
                    resolve(reader.result);
                } else {
                    reject('erro');
                }
            };
            reader.onerror = error => reject(error);
        });
    }

    private handleChangePartnerUpload (event: any) {
        this.setState({partnerSelected: event.target.value});
    };

    private handleChangeFile (event:any) {
        const files = event.target.files;
        if(files && files && files !== undefined) {
            this.setState({file:files[0]});
        } else {
            this.props.openSnackMessage("É necessário selecionar 1 arquivo de formato .xlsx");
        }
    }

    private setPartnersList(response:any) {
        if(response && response.data && response.data.findVejaPartners) {
            this.setState({partners:response.data.findVejaPartners});
        }
    }

}


// WEBPACK FOOTER //
// ./src/component/panel/shared/component/DialogImportPartnerData.tsx